import { useEffect, useState } from 'react';
import { ReactComponent as Phone } from 'Assets/links/grey-phone.svg';
import { ReactComponent as Email } from 'Assets/links/email.svg';
import { Segmented } from 'antd';
import { useSelector } from 'react-redux';
import { selectCurrentOrder } from 'Redux/Order/slice';
import { selectCurrentDriver } from 'Redux/Driver/slice';
import { capitalizeFirstLetter, clearPhoneNumber } from 'Shared/Utils';
import styles from './Contacts.module.scss';

type ContactType = 'driver' | 'broker';
type ContactInfoType = { name: string; phone: string; email: string };

export const Contacts = () => {
  const currentOrder = useSelector(selectCurrentOrder);
  const currentDriver = useSelector(selectCurrentDriver);
  const [contacts, setContacts] = useState<
    Record<ContactType, ContactInfoType>
  >({
    broker: { name: '', phone: '', email: '' },
    driver: { name: '', phone: '', email: '' },
  });
  const [currentContact, setCurrentContact] = useState<ContactType>('broker');

  useEffect(() => {
    if (currentOrder) {
      const { broker, broker_phone, email } = currentOrder;

      setContacts((prevState) => ({
        ...prevState,
        broker: {
          name: broker || '',
          phone: broker_phone || '',
          email: email || '',
        },
      }));
    }
  }, [currentOrder]);

  useEffect(() => {
    if (currentDriver) {
      const { first_name, last_name, email, phone_number } =
        currentDriver.driver;

      setContacts((prevState) => ({
        ...prevState,
        driver: {
          name: first_name && last_name ? `${first_name} ${last_name}` : '',
          phone: phone_number || '',
          email: email || '',
        },
      }));
    }
  }, [currentDriver]);

  return (
    <div className={styles.contacts}>
      <Segmented
        className={styles.contacts__switcher}
        options={Object.keys(contacts).map((value) =>
          capitalizeFirstLetter(value),
        )}
        onChange={(value) => {
          const nextContact = String(value).toLowerCase() as ContactType;

          setCurrentContact(nextContact);
        }}
        defaultValue={capitalizeFirstLetter(currentContact)}
      />

      <span className={styles.contacts__label}>Responsible</span>

      <div className={styles.contact}>
        <span className={styles.contact__name}>
          {contacts[currentContact].name}
        </span>
        <div className={styles.contact__links}>
          {contacts[currentContact].phone && (
            <a
              className={styles.contact__link}
              href={`tel:${clearPhoneNumber(contacts[currentContact].phone)}`}
              target="_blank"
              rel="noreferrer"
            >
              <Phone
                className={styles.contact__icon}
                title={`Make a call to the ${currentContact}`}
              />
            </a>
          )}
          <a
            className={styles.contact__link}
            href={`mailto:${contacts[currentContact].email}`}
            target="_blank"
            rel="noreferrer"
          >
            <Email
              className={styles.contact__icon}
              title={`Send an email to the ${currentContact}`}
            />
          </a>
        </div>
      </div>
    </div>
  );
};
